import React from "react";
import PropTypes from "prop-types";

import { DEFAULT_CARD_HEIGHT } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";
import IssuesModule from "stream/containers/IssuesModule";

export default function DeepDiveTagStream({ deepDive }) {
  const { slug, title, image, ogImage, issuesModuleConfig } = deepDive;

  const streamShoe = issuesModuleConfig
    ? () => <IssuesModule moduleSlug={slug} boxes={issuesModuleConfig} />
    : null;

  return (
    <>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={slug}>
        {({ streamParams }) => (
          <>
            <PromoStreamCap
              promo={{
                title: title,
                content: (
                  <span>
                    Explore below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link&page=axios"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    for more deep dives into the most important topics affecting
                    our world.
                  </span>
                ),
                contentForAnalytics:
                  "Explore below and sign up for Axios AM for more deep dives into the most important topics affecting our world.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              streamShoeComponent={streamShoe}
            />
          </>
        )}
      </TagStreamWrapper>
    </>
  );
}

DeepDiveTagStream.propTypes = {
  deepDive: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    ogImage: PropTypes.string,
    issuesModuleConfig: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        tagSlug: PropTypes.string.isRequired,
        backgroundColor: PropTypes.string,
      })
    ),
  }).isRequired,
};
